module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": "Tipo, Condição e Envio"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Condição",
      "columns": 4,
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.condition),
      expression: "product.condition"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product, "condition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.category.settings.item_conditions), function(condition) {
    return _c('option', {
      key: condition,
      domProps: {
        "value": condition
      }
    }, [_vm._v(_vm._s(_vm.$t(("mercadoLivre.conditions." + condition + ".label"))))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Tipo checkout"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeCheckout),
      expression: "typeCheckout"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.typeCheckout) ? _vm._i(_vm.typeCheckout, null) > -1 : (_vm.typeCheckout)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.typeCheckout,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.typeCheckout = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.typeCheckout = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.typeCheckout = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se o anúncio será do tipo \"checkout\" para usar buybox.")])]), _vm._v(" "), _c('form-group', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "label": "Envio",
      "columns": 4,
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.shippingMode),
      expression: "product.shippingMode"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product, "shippingMode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.onChangeShippingOption(_vm.product.shippingMode)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.category.settings.shipping_options), function(shippingOption) {
    return _c('option', {
      key: shippingOption,
      domProps: {
        "value": shippingOption
      }
    }, [_vm._v(_vm._s(_vm.$t(("mercadoLivre.shippingOptions." + shippingOption + ".label"))))])
  })], 2)]), _vm._v(" "), _vm._l((_vm.configurations), function(announcementConfiguration) {
    var this$1 = this;

    return _c('general-shipping-rules', {
      attrs: {
        "accountQuantity": _vm.accountQuantity,
        "product": _vm.product,
        "announcementConfiguration": announcementConfiguration,
        "selectedShippingOption": _vm.selectedShippingOption
      },
      on: {
        "loading": function (l) {
          this$1.loading = l
        }
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfa46cfa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/general/Details.vue
// module id = 3438
// module chunks = 0